import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoader: false,
  classificationLength: 0,
  classification: [],
  classificationError: "",
  formError: "",
}

export default function classificationReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_CLASSIFICATION:
      return {...state, loading: action.payload}
    case actions.SAVE_LOADER_CLASSIFICATION:
      return {...state, saveLoader: action.payload}
    case actions.GET_CLASSIFICATION:
      return {...state, classification: action.payload.classification, classificationLength: action.payload.classificationLength}
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.CLASSIFICATION_FAIL:
      return { ...state, classificationError: action.payload };
    default:
      return {...state};
  }
}